const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const getExtrastockTypeLabel = (type, extrastockType) => {
  const match = extrastockType?.find((item) => item.value === type);
  return match?.title || type;
};

export const getExtrastockViewSections = (t, item, { extrastockType } = {}) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Informazioni Generali'),
      fields: [
        { text: t('Unità'), value: display(item.title) },
        { text: t('MQ'), value: display(item.square) },
        {
          text: t('Tipologia Stock'),
          value: display(
            getExtrastockTypeLabel(item.extrastock_type, extrastockType),
          ),
        },
        {
          text: t('Outlet Village'),
          value: display(
            item['shopping_centers.title'] || item.shopping_center?.title,
          ),
        },
        {
          text: t('Listino canone d’affitto (€/mese)'),
          value: display(item.rent_price),
        },
        {
          text: t('Listino utenze (€/mese)'),
          value: display(item.consumption_price),
        },
        { text: t('Note'), value: display(item.comments) },
      ],
    },
  ];
};
